import { createSelector } from 'reselect';
import { actionTypes } from '../actions';
import { EN, langs } from '../utils/consts';
import { selectApplicationUserSupportId } from './application';


const initialLoggedInUser = {
  loading: false,
  refreshFailed: false,
  refreshError: null,
};
export const loggedInUser = (state = { ...initialLoggedInUser }, action) => {
  let user;
  switch (action.type) {
    case actionTypes.LOG_IN_FAILURE:
      return {
        ...state,
        loading: false,
        refreshFailed: false,
        refreshError: null,
      };
    case actionTypes.LOG_IN:
      return {
        ...state,
        loading: true,
        refreshFailed: false,
        refreshError: null,
      };
    case actionTypes.SIGN_IN_PUT_RESPONSE: {
      const { userAuth, userData } = action.payload;

      user = userData;
      user.userAuth = userAuth;

      return {
        ...state,
        ...user,
        loading: false,
        refreshFailed: false,
        refreshError: null,
      };
    }

    case actionTypes.EDIT_SUCCESS:
      user = action.userData;
      user.userAuth = action.userAuth;
      return { ...user };

    case actionTypes.EDIT_FAILURE:
      return {
        ...state,
        errorInUpdate: true,
      };

    case actionTypes.LOGGED_OFF:
      return {};

    case actionTypes.PHOTO_UPLOADED:
      return {
        ...state,
        avatar: action.photo,
        avatarUploadError: '',
      };
    case actionTypes.PHOTO_UPLOAD_FAILURE:
      return {
        ...state,
        avatarUploadError: action.errorMsg,
      };
    case actionTypes.PHOTO_UPLOAD_CLEAR_STATUS:
      return {
        ...state,
        avatarUploadError: '',
      };
    case actionTypes.SET_STATE_SUCCESS:
      return {
        ...state,
        pro: state.pro ? {
          ...state.pro,
          proState: {
            proWork: action.payload.proWork,
            proHideProfile: action.payload.proHideProfile,
            proBookingAccept: action.payload.proBookingAccept,
          },
        } : null,
        state: action.payload,
      };
    case actionTypes.UPDATE_USER_SETTINGS:
      return {
        ...state,
        userSettingsLoading: true,
      };
    case actionTypes.UPDATE_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        userSettingsLoading: false,
        ...action.payload,
      };
    case actionTypes.UPDATE_USER_SETTINGS_FAILURE:
      return {
        ...state,
        userSettingsLoading: false,
      };
    case actionTypes.REFRESH_LOGGED_IN_USER_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        refreshFailed: false,
        refreshError: null,
      };
    case actionTypes.REFRESH_LOGGED_IN_USER_DETAILS_FAILURE:
      return {
        ...state,
        refreshFailed: true,
        refreshError: action.error,
      };
    default:
      return state;
  }
};

export const selectLoggedInUser = (state) => state.loggedInUser;

export const selectLoggedInUserId = createSelector(
  selectLoggedInUser,
  /**
   *
   * @param {{ id?: number }} loggedInUserState
   * @return {number || null}
   */
  (loggedInUserState) => loggedInUserState.id || null,
);

export const selectLoggedInUserAuth = createSelector(
  selectLoggedInUser,
  (loggedInUserState) => loggedInUserState.userAuth,
);

export const selectLoggedInUsersDevice = createSelector(
  selectLoggedInUser,
  (loggedInUserState) => loggedInUserState.numericDeviceId,
);

export const selectLoggedInUserIsSupport = createSelector(
  selectLoggedInUserId,
  selectApplicationUserSupportId,
  (loggedInUserId, userSupportId) => (
    loggedInUserId && loggedInUserId === userSupportId
  ),
);

export const selectLoggedInUserIsPro = createSelector(
  selectLoggedInUser,
  (loggedInUserState) => loggedInUserState.pro !== null,
);

export const localeGet = () => {
  const path = window.location.pathname.split('/')[1];
  return Object.keys(langs).find((el) => langs[el].code === path) || '';
};
export const locale = (state = { locale: localeGet() || EN }, action) => {
  const { lang = EN } = action;
  switch (action.type) {
    case actionTypes.CHANGE_LOCALE:
      return {
        ...state,
        locale: lang,
      };
    case actionTypes.CHANGE_LOCALE_LANGS:
      return {
        ...state,
        languages: action.langs,
      };
    default:
      return state;
  }
};

export const selectLocale = (state) => state.locale.locale;

export const logInError = (state = false, action) => {
  switch (action.type) {
    case actionTypes.LOG_IN_FAILURE:
      return new Date().getTime();
    case actionTypes.LOG_IN_SUCCESS:
      return '';
    default:
      return state;
  }
};

export const registerSuccess = (state = false, action) => {
  switch (action.type) {
    case actionTypes.REGISTER_SUCCESS:
      return true;
    case actionTypes.LOG_IN_SUCCESS:
      return true;
    default:
      return state;
  }
};
export const registerFailureMessage = (state = '', action) => {
  switch (action.type) {
    case actionTypes.REGISTER_FAILURE:
      return action.message != null ? action.message : '';

    case actionTypes.REGISTRATION_PENDING_ACTIVATION:
    case actionTypes.REGISTER_SUCCESS:
      return '';

    default:
      return state;
  }
};


export const resetSuccess = (state = false, action) => {
  switch (action.type) {
    case actionTypes.RESET_SUCCESS:
      return true;

    case actionTypes.FORGOT_PASSWORD_RESET:
      return false;

    default:
      return state;
  }
};
export const resetFailure = (state = '', action) => {
  switch (action.type) {
    case actionTypes.RESET_FAILURE:
      return action.message;

    case actionTypes.FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

/* export const proCalls = (state = [], action) => {
  switch (action.type) {

    case actionTypes.PRO_CALLS_RECEIVED:
      return action.calls;

    default:
      return state;
  }
};
//
export const personalCalls = (state = [], action) => {
  switch (action.type) {

    case actionTypes.PERSONAL_CALLS_RECEIVED:
      return action.calls;

    default:
      return state;
  }
}; */

export const activity = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.PERSONAL_CALLS_RECEIVED:
      return {
        ...state,
        personCalls: action.calls.slice(0, 10),
      };

    case actionTypes.PRO_CALLS_RECEIVED:
      return {
        ...state,
        proCalls: action.calls.slice(0, 10),
      };

    default:
      return state;
  }
};

const transactionsInitialState = {
  availableAmount: 0,
  transactions: [],
  total: 0,
  proBalance: 0,
  balance: 0,
  transactionId: '',
  added: 0,
  topUpLoading: false,
};

export const transactions = (state = { ...transactionsInitialState }, action) => {
  switch (action.type) {
    case actionTypes.TRANSACTIONS_RECEIVED:
      return {
        ...state,
        transactions: action.payload.results,
        total: action.payload.total,
        proBalance: action.payload.proBalance,
        balance: action.payload.balance,
        loading: false,
      };

    case actionTypes.WITHDRAW_RECEIVED:
      return {
        ...state,
        availableAmount: action.payload.availableAmount,
      };

    case actionTypes.RESET_TRANSACTIONS:
      return {
        ...transactionsInitialState,
      };
    case actionTypes.GET_TRANSACTIONS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.GET_WITHDRAW_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.TOP_UP_SUCCESS:
      return {
        ...state,
        balance: action.payload.telmieBalance,
        transactionId: action.payload.transactionId,
        added: action.payload.totalAddTelmie,
        status: action.payload.status,
        loading: false,
        topUpLoading: false,
      };
    case actionTypes.TOP_UP_PENDING:
      return {
        ...state,
        pendingData: action.payload,
        status: action.payload.status,
        topUpLoading: false,
      };
    case actionTypes.TOP_UP_FAILURE:
      return {
        ...state,
        topUpLoading: false,
      };
    case actionTypes.TOP_UP:
      return {
        ...state,
        topUpLoading: true,
        status: '',
      };

    default:
      return state;
  }
};

export const verifySuccess = (state = false, action) => {
  switch (action.type) {
    case actionTypes.VERIFY_SUCCESS:
      return true;
    default:
      return state;
  }
};
export const verifyFailure = (state = false, action) => {
  switch (action.type) {
    case actionTypes.VERIFY_FAILURE:
      return true;

    default:
      return state;
  }
};


export const pendingActivation = (state = { pending: false }, action) => {
  switch (action.type) {
    case actionTypes.REGISTRATION_PENDING_ACTIVATION:
      return {
        ...state,
        pending: action.payload,
      };
    default:
      return state;
  }
};
export const sendCodeFailureMessage = (state = '', action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

export const sendCodeSuccess = (state = '', action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

export const verifyCodeSuccess = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_RESET:
      return false;

    default:
      return state;
  }
};

export const verifyCodeFailureMessage = (state = '', action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_RESET:
      return '';

    default:
      return state;
  }
};

export const dataFromServer = (state = {}, action) => {
  let newCategories;
  switch (action.type) {
    case actionTypes.SET_CATEGORIES:
      newCategories = action.categories.reduce((prevCategories, category) => ({
        categories: [...prevCategories.categories, category.name],
        subCategories: {
          ...prevCategories.subCategories,
          [category.name]: category.childs.map((categoryChild) => categoryChild.name),
        },
      }), { categories: [], subCategories: {} });

      return {
        ...state,
        ...newCategories,
        sectorsFullObject: action.categories,
      };
    default:
      return state;
  }
};

export const sendContactMessage = (state = { errorMsg: '', isSent: false }, action) => {
  switch (action.type) {
    case actionTypes.SEND_CONTACT_MESS:
      return {
        ...state,
        isSent: false,
        errorMsg: '',
      };
    case actionTypes.SEND_CONTACT_MESS_FAILURE:
      return {
        ...state,
        errorMsg: action.message != null ? action.message : '',
      };
    case actionTypes.SEND_CONTACT_MESS_SUCCESS:
      return {
        ...state,
        isSent: true,
        errorMsg: '',
      };
    default:
      return state;
  }
};

const initialAvailability = {
  loading: false,
};

export const availability = (state = { ...initialAvailability }, action) => {
  switch (action.type) {
    case actionTypes.GET_AVAILABILITY:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.GET_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.results,
      };
    case actionTypes.SET_AVAILABILITY:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.SET_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SET_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.results,
      };
    case actionTypes.UPDATE_AVAILABILITY:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.UPDATE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.results,
      };
    case actionTypes.DELETE_AVAILABILITY:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.DELETE_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.results,
      };

    case actionTypes.LOGGED_OFF:
      return {
        ...initialAvailability,
      };

    default:
      return state;
  }
};

const initialBranchIoState = {};

export const branchIo = (state = initialBranchIoState, action) => {
  switch (action.type) {
    case actionTypes.BRANCH_IO_DATA:
      return {
        ...state,
        name: action.payload.name,
        value: action.payload.value,
      };

    case actionTypes.GET_DEEP_LINK_SUCCESS:
      return {
        ...state,
        link: action.payload,
      };
    case actionTypes.LOGGED_OFF:
      return {
        ...initialBranchIoState,
      };
    default:
      return state;
  }
};

export const globalMessage = (state = { message: '' }, action) => {
  switch (action.type) {
    case actionTypes.CREATE_CALL_ERROR:
      return {
        message: action.info,
      };
    case actionTypes.GLOBAL_MESSAGE:
      return {
        message: action.payload,
      };

    default:
      return state;
  }
};

export const redirect = (state = { refId: '' }, action) => {
  switch (action.type) {
    case actionTypes.SET_REDIRECT_LINK:
      return {
        refId: action.payload,
      };
    default:
      return state;
  }
};

export const badges = (state = {}, action) => {
  let userBadges;
  let data;
  let personInfo;
  let currentUser;
  let newTotalMissedCall;
  let newTotalMissedMessage;
  let updatedUser;
  switch (action.type) {
    case actionTypes.GET_BADGE_SUCCESS:
      userBadges = {};
      action.payload.badges.forEach((item) => {
        userBadges[item.toUser.id] = item;
      });
      data = {
        totalMissedCall: action.payload.totalMissedCall,
        totalMissedMessage: action.payload.totalMissedMessage,
        badges: userBadges,
      };
      return {
        data,
      };
    case actionTypes.CHANGE_UNREAD_MSG:
      personInfo = action.from.personInfo;
      currentUser = state.data.badges[personInfo.personID] || { missedCall: 0, missedMessage: 0 };
      newTotalMissedCall = state.data.totalMissedCall - currentUser.missedCall + personInfo.missedCallsCount;
      newTotalMissedMessage = state.data.totalMissedMessage - currentUser.missedMessage + personInfo.missedMessagesCount;
      updatedUser = {
        toID: personInfo.personID,
        missedCall: personInfo.missedCallsCount,
        missedMessage: personInfo.missedMessagesCount,
        toUser: currentUser.toUser || personInfo.toUser,
      };
      return {
        data: {
          ...state.data,
          totalMissedCall: newTotalMissedCall,
          totalMissedMessage: newTotalMissedMessage,
          badges: {
            ...state.data.badges,
            [updatedUser.toUser.id]: updatedUser,
          },
        },
      };
    case actionTypes.GET_BADGE_FAILURE:
      return {
        message: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/user.js